import { API, axios, CREATE_NEW_CLIENTS_URL, NextServerCookies, SendRequest, toastr } from '@/imports-files/pages/admins/dashboard/clients/add-users';


export class AddUsers extends SendRequest 
{
  
  async createNewClientUser(params, client_id) 
  {
    try {
            const result = await axios.post( API.admins.dashboard.clients.users.CREATE_NEW_CLIENTS_URL.replace('$client_id', client_id),
                params,
                this.setHeaderJSON(),
                this.setCrossDomainTrue(),
                this.setCredentialsJSON());

            return result;
        } catch (error) {
          return error;
        }
  }


  async getClientUserRoles(client_auth_cookies) {
    try {
      const result = await axios({
        method: 'get',
        url: API.client.welcome.invite_admin,
        headers: {cookie: `Authorization=${client_auth_cookies}`},
      });     

      return result;
    } catch (error) {
      return error;
    }
  }

  async getUserRoles() 
  {
    try {
            const result = await axios.get( API.admins.dashboard.clients.users.GET_NEW_CLIENT_ROLE_URL,
                {},
                this.setHeaderJSON(),
                this.setCrossDomainTrue(),
                this.setCredentialsJSON());

            return result;
        } 
    catch (error) {
                    return error;
                  }
  }

}
